import { SET_CARD } from 'client/constants/actions';
import { CardData } from 'types/story';

export function setCard(payload: CardData) {
	return {
		type: SET_CARD,
		payload,
	};
}
